import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import InputMask from 'react-input-mask';
import { useReCaptcha } from "next-recaptcha-v3";
import { fetchPostEmailSendContact, fetchGetCompanySubsidiaries } from "../../../services/api";

export default function ContactUsContactForm({ company }) {
    const [formPost, setFormPost] = useState({ isLoading: false, isError: false, errorText: '', isSuccess: false });
    const { register, handleSubmit, formState: { errors }, setValue } = useForm();
    const { executeRecaptcha } = useReCaptcha();

    const onSubmit = async data => {
        const token = await executeRecaptcha("contactSubmit");
        setFormPost({ ...formPost, isLoading: true, isError: false, errorText: '', isSuccess: false });
        fetchPostEmailSendContact({
            cellPhone: data.txtCellPhone,
            email: data.txtEmail,
            message: data.txtMessage,
            name: data.txtName,
            token
        })
            .then(res => {
                if (res) {
                    setValue('txtName', '');
                    setValue('txtEmail', '');
                    setValue('txtCellPhone', '');
                    setValue('txtMessage', '');
                    setFormPost({ ...formPost, isLoading: false, isSuccess: true });
                }
            })
            .catch(err => { setFormPost({ ...formPost, isLoading: false, isError: true, errorText: err.toString() }); });
    }

    const [subsidiaries, setSubsidiaries] = useState([])

    useEffect(() => {
        fetchGetCompanySubsidiaries()
            .then(res => {
                const subs = res.map(item => ({
                    city: item.addressCity,
                    federativeUnit: item.addressFederativeUnit,
                    postalCode: item.addressPostalCode,
                    address: item.addressStreet,
                    email: item.email,
                    phone: item.phone,
                    phone2: item.phone2,
                    whatsapp: item.whatsapp,
                    whatsapp2: item.whatsapp2
                }))
                setSubsidiaries(subs)
            })
    }, [])

    return (
        <section className="contact-section ptb-40">
            <div className="container">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="contact-box bg-white rounded iv_sidebar_widget iv_seller_widget p-4">
                            <div className="contact-header">
                                <div className="my-icon-circle">
                                    <svg viewBox="0 0 24 24" width="50" height="50" fill="none" stroke="#0B45CB" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.5 21.5V4.7c0-.66.44-1.24 1.08-1.42L13 1.3v20.2" />
                                        <path d="M13 1.3l3.7 3.3c.2.18.3.43.4.1v4.6" />
                                        <path d="M6.3 6.7l6.7-2" />
                                        <path d="M6.3 9.4l6.7-2" />
                                        <path d="M6.3 14.8l3.3-1" />

                                        <rect x="8.6" y="0.5" width="1.3" height="2.4" rx="0.65" />

                                        <path d="M8.2 21.5v-3.8c0-.5.4-.9.9-.9h1.8c.5 0 .9.4.9.9v3.8" />
                                        <path d="M9.6 16.8v4.7" />

                                        <path d="M13 9.4h5.6c.7 0 1.3.6 1.3 1.3v10.8" />
                                        <rect x="14.3" y="10.9" width="3.3" height="1.5" rx="0.3" />
                                        <rect x="14.3" y="13.5" width="3.3" height="1.5" rx="0.3" />
                                        <rect x="14.3" y="16.1" width="1.5" height="1.2" rx="0.25" />

                                        <path d="M0.5 21.5c0-1.8 1.4-3.2 3.2-3.2h.8v3.2" />

                                        <path d="M0.5 21.5h23" />
                                    </svg>
                                </div>
                                <div className="flex-column">
                                    <h3>{subsidiaries ? "Matriz" : "Loja"}</h3>
                                    <div className="d-flex align-items-center justify-content-start gap-2">
                                        <i className="fas fa-location-dot"></i>
                                        <p className="mb-0">{`${company.address} - ${company.city} - ${company.federativeUnit} - ${company.postalCode}`}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="contact-body gap-1">
                                <div className="col-lg-8 d-flex justify-content-around flex-wrap gap-1 phone">
                                    <div className="contact-information">
                                        <div className="my-icon-circle" style={{ height: "65px", width: "65px" }}>
                                            <i className="fas fa-phone" style={{ fontSize: "30px" }}></i>
                                        </div>
                                        <div className="contact-number">
                                            <p className="mb-0">Telefone Fixo {company.phone ? "1" : null}</p>
                                            <a className="mb-0" href={`tel:+55${company.phone}`}>
                                                {
                                                    company.phone.length === 10
                                                        ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 6)}-${company.phone.substring(6, 10)}`
                                                        : company.phone.length === 11
                                                            ? `(${company.phone.substring(0, 2)}) ${company.phone.substring(2, 7)}-${company.phone.substring(7, 11)}`
                                                            : company.phone
                                                }
                                            </a>
                                        </div>
                                    </div>
                                    <div className="contact-information">
                                        <div className="my-icon-circle-whatsapp" style={{ height: "65px", width: "65px" }}>
                                            <i className="fab fa-whatsapp" style={{ fontSize: "30px" }}></i>
                                        </div>
                                        <div className="contact-number">
                                            <p className="mb-0">Whatsapp {company.whatsapp ? "1" : null}</p>
                                            <a className="mb-0 green" href={`tel:+55${company.whatsapp}`}>
                                                {
                                                    company.whatsapp.length === 10
                                                        ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 6)}-${company.whatsapp.substring(6, 10)}`
                                                        : company.whatsapp.length === 11
                                                            ? `(${company.whatsapp.substring(0, 2)}) ${company.whatsapp.substring(2, 7)}-${company.whatsapp.substring(7, 11)}`
                                                            : company.whatsapp
                                                }
                                            </a>
                                        </div>
                                    </div>
                                    {company.phone2 ?
                                        <div className="contact-information">
                                            <div className="my-icon-circle" style={{ height: "65px", width: "65px" }}>
                                                <i className="fas fa-phone" style={{ fontSize: "30px" }}></i>
                                            </div>
                                            <div className="contact-number">
                                                <p className="mb-0">Telefone Fixo 2</p>
                                                <a className="mb-0" href={`tel:+55${company.phone2}`}>
                                                    {
                                                        company.phone2.length === 10
                                                            ? `(${company.phone2.substring(0, 2)}) ${company.phone2.substring(2, 6)}-${company.phone2.substring(6, 10)}`
                                                            : company.phone2.length === 11
                                                                ? `(${company.phone2.substring(0, 2)}) ${company.phone2.substring(2, 7)}-${company.phone2.substring(7, 11)}`
                                                                : company.phone2
                                                    }
                                                </a>
                                            </div>
                                        </div>
                                        : null}
                                    {company.whatsapp2 ?
                                        <div className="contact-information">
                                            <div className="my-icon-circle-whatsapp" style={{ height: "65px", width: "65px" }}>
                                                <i className="fab fa-whatsapp" style={{ fontSize: "30px" }}></i>
                                            </div>
                                            <div className="contact-number">
                                                <p className="mb-0">Whatsapp 2</p>
                                                <a className="mb-0 green" href={`tel:+55${company.whatsapp2}`}>
                                                    {
                                                        company.whatsapp2.length === 10
                                                            ? `(${company.whatsapp2.substring(0, 2)}) ${company.whatsapp2.substring(2, 6)}-${company.whatsapp2.substring(6, 10)}`
                                                            : company.whatsapp2.length === 11
                                                                ? `(${company.whatsapp2.substring(0, 2)}) ${company.whatsapp2.substring(2, 7)}-${company.whatsapp2.substring(7, 11)}`
                                                                : company.whatsapp2
                                                    }
                                                </a>
                                            </div>
                                        </div>
                                        : null}
                                </div>
                                <div className="col-lg-4 email">
                                    <div className="email-information">
                                        <div className="my-icon-circle" style={{ height: "65px", width: "65px" }}>
                                            <i className="flaticon-email" style={{ fontSize: "30px" }}></i>
                                        </div>
                                        <div className="contact-number">
                                            <p className="mb-0">E-mail</p>
                                            <a className="mb-0" href={`mailto:${company.email}}`}>{company.email}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {subsidiaries.length > 0 && subsidiaries.map((item, index) => (
                        <div className="col-xl-12 mt-4" key={index}>
                            <div className="contact-box bg-white rounded iv_sidebar_widget iv_seller_widget p-4">
                                <div className="contact-header">
                                    <div className="my-icon-circle">
                                        <svg viewBox="0 0 24 24" width="50" height="50" fill="none" stroke="#0B45CB" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.5 21.5V4.7c0-.66.44-1.24 1.08-1.42L13 1.3v20.2" />
                                            <path d="M13 1.3l3.7 3.3c.2.18.3.43.4.1v4.6" />
                                            <path d="M6.3 6.7l6.7-2" />
                                            <path d="M6.3 9.4l6.7-2" />
                                            <path d="M6.3 14.8l3.3-1" />

                                            <rect x="8.6" y="0.5" width="1.3" height="2.4" rx="0.65" />

                                            <path d="M8.2 21.5v-3.8c0-.5.4-.9.9-.9h1.8c.5 0 .9.4.9.9v3.8" />
                                            <path d="M9.6 16.8v4.7" />

                                            <path d="M13 9.4h5.6c.7 0 1.3.6 1.3 1.3v10.8" />
                                            <rect x="14.3" y="10.9" width="3.3" height="1.5" rx="0.3" />
                                            <rect x="14.3" y="13.5" width="3.3" height="1.5" rx="0.3" />
                                            <rect x="14.3" y="16.1" width="1.5" height="1.2" rx="0.25" />

                                            <path d="M0.5 21.5c0-1.8 1.4-3.2 3.2-3.2h.8v3.2" />

                                            <path d="M0.5 21.5h23" />
                                        </svg>
                                    </div>
                                    <div className="flex-column">
                                        <h3>Filial {index + 1}</h3>
                                        <div className="d-flex align-items-center justify-content-start gap-2">
                                            <i className="fas fa-location-dot"></i>
                                            <p className="mb-0">{`${item.address} - ${item.city} - ${item.federativeUnit} - ${item.postalCode}`}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="contact-body gap-1">
                                    <div className="col-lg-8 d-flex justify-content-around flex-wrap gap-1 phone">
                                        <div className="contact-information">
                                            <div className="my-icon-circle" style={{ height: "65px", width: "65px" }}>
                                                <i className="fas fa-phone" style={{ fontSize: "30px" }}></i>
                                            </div>
                                            <div className="contact-number">
                                                <p className="mb-0">Telefone Fixo {item.phone ? "1" : null}</p>
                                                <a className="mb-0" href={`tel:+55${item.phone}`}>
                                                    {
                                                        item.phone.length === 10
                                                            ? `(${item.phone.substring(0, 2)}) ${item.phone.substring(2, 6)}-${item.phone.substring(6, 10)}`
                                                            : item.phone.length === 11
                                                                ? `(${item.phone.substring(0, 2)}) ${item.phone.substring(2, 7)}-${item.phone.substring(7, 11)}`
                                                                : item.phone
                                                    }
                                                </a>
                                            </div>
                                        </div>
                                        <div className="contact-information">
                                            <div className="my-icon-circle-whatsapp" style={{ height: "65px", width: "65px" }}>
                                                <i className="fab fa-whatsapp" style={{ fontSize: "30px" }}></i>
                                            </div>
                                            <div className="contact-number">
                                                <p className="mb-0">Whatsapp {item.whatsapp ? "1" : null}</p>
                                                <a className="mb-0 green" href={`tel:+55${item.whatsapp}`}>
                                                    {
                                                        item.whatsapp.length === 10
                                                            ? `(${item.whatsapp.substring(0, 2)}) ${item.whatsapp.substring(2, 6)}-${item.whatsapp.substring(6, 10)}`
                                                            : item.whatsapp.length === 11
                                                                ? `(${item.whatsapp.substring(0, 2)}) ${item.whatsapp.substring(2, 7)}-${item.whatsapp.substring(7, 11)}`
                                                                : item.whatsapp
                                                    }
                                                </a>
                                            </div>
                                        </div>
                                        {item.phone2 ?
                                            <div className="contact-information">
                                                <div className="my-icon-circle" style={{ height: "65px", width: "65px" }}>
                                                    <i className="fas fa-phone" style={{ fontSize: "30px" }}></i>
                                                </div>
                                                <div className="contact-number">
                                                    <p className="mb-0">Telefone Fixo 2</p>
                                                    <a className="mb-0" href={`tel:+55${item.phone2}`}>
                                                        {
                                                            item.phone2.length === 10
                                                                ? `(${item.phone2.substring(0, 2)}) ${item.phone2.substring(2, 6)}-${item.phone2.substring(6, 10)}`
                                                                : item.phone2.length === 11
                                                                    ? `(${item.phone2.substring(0, 2)}) ${item.phone2.substring(2, 7)}-${item.phone2.substring(7, 11)}`
                                                                    : item.phone2
                                                        }
                                                    </a>
                                                </div>
                                            </div>
                                            : null}
                                        {item.whatsapp2 ?
                                            <div className="contact-information">
                                                <div className="my-icon-circle-whatsapp" style={{ height: "65px", width: "65px" }}>
                                                    <i className="fab fa-whatsapp" style={{ fontSize: "30px" }}></i>
                                                </div>
                                                <div className="contact-number">
                                                    <p className="mb-0">Whatsapp 2</p>
                                                    <a className="mb-0 green" href={`tel:+55${item.whatsapp2}`}>
                                                        {
                                                            item.whatsapp2.length === 10
                                                                ? `(${item.whatsapp2.substring(0, 2)}) ${item.whatsapp2.substring(2, 6)}-${item.whatsapp2.substring(6, 10)}`
                                                                : item.whatsapp2.length === 11
                                                                    ? `(${item.whatsapp2.substring(0, 2)}) ${item.whatsapp2.substring(2, 7)}-${item.whatsapp2.substring(7, 11)}`
                                                                    : item.whatsapp2
                                                        }
                                                    </a>
                                                </div>
                                            </div>
                                            : null}
                                    </div>
                                    <div className="col-lg-4 email">
                                        <div className="email-information">
                                            <div className="my-icon-circle" style={{ height: "65px", width: "65px" }}>
                                                <i className="flaticon-email" style={{ fontSize: "30px" }}></i>
                                            </div>
                                            <div className="contact-number">
                                                <p className="mb-0">E-mail</p>
                                                {/* Correção extra opcional: remova a chave dupla fechando company.email }} se houver */}
                                                <a className="mb-0" href={`mailto:${item.email}`}>{item.email}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className="col-xl-12 mt-4">
                        <div className="contact-form-area bg-white rounded iv_sidebar_widget iv_seller_widget p-4">
                            <h4 className="mb-3" style={{ textAlign: "center" }}>Entre em Contato</h4>



                            <form onSubmit={handleSubmit(onSubmit)} className="ct-form-wrapper">
                                <div className="row g-4">
                                    <div className="col-12">
                                        <div className="input-field">
                                            <label>Nome</label>
                                            <input type="text" placeholder="Nome Completo" {...register("txtName", { required: true })} required={errors.txtName} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-field">
                                            <label>Email</label>
                                            <input type="email" placeholder="Email" {...register("txtEmail", { required: true, pattern: /^\S+@\S+$/i })} required={errors.txtEmail} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="input-field">
                                            <label>Celular</label>
                                            <InputMask type={'tel'} mask="(99) 99999-9999" maskChar=" " placeholder="Celular" {...register("txtCellPhone", { required: true })} required={errors.txtCellPhone} />
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="input-field">
                                            <label>Mensagem</label>
                                            <textarea placeholder="Mensagem" rows="5" {...register("txtMessage", { required: true })} required={errors.txtMessage}></textarea>
                                        </div>
                                    </div>
                                </div>
                                {
                                    formPost.isError
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="error-badge bg-primary-light rounded d-block">{formPost.errorText}</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    formPost.isSuccess
                                        ? <div className="row mt-4">
                                            <div className="col-12">
                                                <div className="success-badge bg-primary-success rounded d-block">Contato enviado com sucesso, aguarde o retorno de nossa equipe!</div>
                                            </div>
                                        </div>
                                        : null
                                }
                                <div className="submit-btn spacing">
                                    <button className="btn btn-primary-contact btn-md mt-3" disabled={formPost.isLoading} type="submit"><i></i><span>Enviar Mensagem</span></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}